import "rxjs/add/operator/map";
import { ReplaySubject } from "rxjs/ReplaySubject";
// Classes.
import { CategoryListVD } from "../viewdata/category-list.vd";
import { CountryListVD } from "../viewdata/country-list.vd";
import { RecordListVD } from "../viewdata/record-list.vd";
import { WCupRankingCategoryListVD } from "../viewdata/wcup-ranking-category-list.vd";
import { WCupRankingListVD } from "../viewdata/wcup-ranking-list.vd";
import { WorldRankingCategoryListVD } from "../viewdata/world-ranking-category-list.vd";
import { WorldRankingListVD } from "../viewdata/world-ranking-list.vd";
import { AthleteListVD } from "../viewdata/athlete-list.vd";
import { AthleteVD } from "../viewdata/athlete.vd";
import { AthleteResultListVD } from "../viewdata/athlete-result-list.vd";
import { EventListVD } from "../viewdata/event-list.vd";
import { NewsListVD } from "../viewdata/news-list.vd";
import { WCupSeasonVD } from "../viewdata/wcup-season.vd";
import { RecordAreasListVD } from "../viewdata/records-area-list.vd";
import { RecordHistoryListVD } from "../viewdata/record-history-list.vd";
import { SeriesView } from "../viewdata/series-list.vd";
import { SeriesProView } from "../viewdata/series-pro.vd";
import { CompetitionDisciplinesVD } from '../viewdata/competitions-discipline-list.vd';
import { CompetitionLevelsVD } from "../viewdata/competitions-level-list.vd";
// Locators.
import { CategoryListLocator } from "../locators/category-list.locator";
import { CountryNamesListLocator } from "../locators/country-names-list.locator";
// Providers.
import { WABaseService } from "./wa-base.service";
import { LoggerService } from "../logger/logger-service";
import { WaHelperService } from "./wa-helper-service";
import { MemStorageService } from "./mem-storage.service";
import { DataFetchService } from "./data-fetch-service";
import { DatabaseService } from "./database-service";
import { AthletesDatabasePouchDbService } from "../wa-services/athletes-database.service";
import { FactoryService } from "./factory-service";
import { EnvironmentService } from "./environment-service";
import { SeriesStageView } from "../viewdata/series-stage.list";
import { SeriesAmateurRankingView } from "../viewdata/series-amateurs-rankings.list";
import { SeriesTeamRankingView } from "../viewdata/series-team-ranking.list";
import { DivisionCategoryListVD } from 'world-archery-lib';
import * as i0 from "@angular/core";
import * as i1 from "../logger/logger-service";
import * as i2 from "./wa-helper-service";
import * as i3 from "./mem-storage.service";
import * as i4 from "./data-fetch-service";
import * as i5 from "./database-service";
import * as i6 from "./athletes-database.service";
import * as i7 from "./factory-service";
import * as i8 from "./environment-service";
export class ViewDataService extends WABaseService {
    constructor(logger, helper, storage, fetchSrvc, db, athDb, factory, env) {
        super(logger, env);
        this.logger = logger;
        this.helper = helper;
        this.storage = storage;
        this.fetchSrvc = fetchSrvc;
        this.db = db;
        this.athDb = athDb;
        this.factory = factory;
        this.env = env;
        this.viewCount = 0;
        this.seasonChangedStream = new ReplaySubject(1);
        this.seasonChangedStream.next(null);
    }
    getInfo() {
        return {
            count: this.viewCount
        };
    }
    get(locator) {
        let viewData;
        let key = locator.getId();
        if (!this.storage.keyExists(key)) {
            // Create ViewData.
            this.createViewData(locator).init();
            this.viewCount++;
        }
        viewData = this.storage.get(key);
        this.debug(`Returning view «${locator.getId()}»`);
        return viewData;
    }
    createViewData(locator) {
        let viewData;
        switch (locator.getType()) {
            case "categoryList":
                viewData = this.createCategoryListVD(locator);
                break;
            case "countryNamesList":
                viewData = this.createCountryNamesListVD(locator);
                break;
            case "recordList":
                viewData = this.createRecordListVD(locator);
                break;
            case "wCupRankingCategoryList":
                viewData = this.createWCupRankingCategoriesListVD(locator);
                break;
            case "wCupRankingList":
                viewData = this.createWCupRankingListVD(locator);
                break;
            case "worldRankingCategoryList":
                viewData = this.createWorldRankingCategoriesListVD(locator);
                break;
            case "worldRankingList":
                viewData = this.createWorldRankingListVD(locator);
                break;
            case "completeAthleteList":
                viewData = this.createCompleteAthleteListVD(locator);
                break;
            case "athlete":
                viewData = this.createAthleteVD(locator);
                break;
            case "eventList":
                viewData = this.createEventListVD(locator);
                break;
            case "news":
                viewData = this.createNewsListVD(locator);
                break;
            case "wCupSeason":
                viewData = this.createWCupSeasonVD(locator);
                break;
            case "athleteResultList":
                viewData = this.createAthleteResultListVD(locator);
                break;
            case "seriesStageLocator":
                viewData = this.createSeriesStateResultListVD(locator);
                break;
            case "seriesAmateursLocator":
                viewData = this.createSeriesAmateursLocator(locator);
                break;
            case "seriesTeamsRankings":
                viewData = this.createSeriesTeamsRankingsLocator(locator);
                break;
            case "recordsAreas":
                viewData = this.createRecordAreasList(locator);
                break;
            case "recordHistoryList":
                viewData = this.createRecordHistoryList(locator);
                break;
            case "seriesList":
                viewData = this.createSeriesList(locator);
                break;
            case "seriesProLocator":
                viewData = this.createProList(locator);
                break;
            case "competitionDisciplinesList":
                viewData = this.createdCompetitionDisciplines(locator);
                break;
            case "competitionLevelsList":
                viewData = this.createdCompetitionLevels(locator);
                break;
            case "divisionCategory":
                viewData = this.createDvisionCategoryListVD(locator);
                break;
            default:
                this.error("Unkonwn locator type");
        }
        this.storage.put(locator.getId(), viewData);
        viewData.connectDependencies();
        this.log(`Created view «${locator.getId()}» with given locator`, viewData, locator);
        return viewData;
    }
    createCategoryListVD(locator) {
        let viewData = new CategoryListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        viewData.configureView();
        return viewData;
    }
    createCountryNamesListVD(locator) {
        let viewData = new CountryListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        viewData.configureView();
        return viewData;
    }
    createRecordListVD(locator) {
        let viewData = new RecordListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let categoryListLocator = new CategoryListLocator();
        let dependendatCategoryListVD = this.get(categoryListLocator);
        let countryListLocator = new CountryNamesListLocator();
        let dependendatCountryListVD = this.get(countryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCategoryListVD);
        viewData.addDependency(dependendatCountryListVD);
        return viewData;
    }
    createWCupRankingCategoriesListVD(locator) {
        let viewData = new WCupRankingCategoryListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let categoryListLocator = new CategoryListLocator();
        let dependendatCategoryListVD = this.get(categoryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCategoryListVD);
        return viewData;
    }
    createWCupRankingListVD(locator) {
        let viewData = new WCupRankingListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let categoryListLocator = new CategoryListLocator();
        let dependendatCategoryListVD = this.get(categoryListLocator);
        let countryListLocator = new CountryNamesListLocator();
        let dependendatCountryListVD = this.get(countryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCategoryListVD);
        viewData.addDependency(dependendatCountryListVD);
        return viewData;
    }
    createWorldRankingCategoriesListVD(locator) {
        let viewData = new WorldRankingCategoryListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let categoryListLocator = new CategoryListLocator();
        let dependendatCategoryListVD = this.get(categoryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCategoryListVD);
        return viewData;
    }
    createWorldRankingListVD(locator) {
        let viewData = new WorldRankingListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let categoryListLocator = new CategoryListLocator();
        let dependendatCategoryListVD = this.get(categoryListLocator);
        let countryListLocator = new CountryNamesListLocator();
        let dependendatCountryListVD = this.get(countryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCategoryListVD);
        viewData.addDependency(dependendatCountryListVD);
        return viewData;
    }
    createCompleteAthleteListVD(locator) {
        let viewData = new AthleteListVD(this.logger, this.fetchSrvc, this.db, this.athDb, this.factory, this.helper, locator);
        let countryListLocator = new CountryNamesListLocator();
        let dependendatCountryListVD = this.get(countryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCountryListVD);
        return viewData;
    }
    createAthleteVD(locator) {
        let viewData = new AthleteVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let countryListLocator = new CountryNamesListLocator();
        let dependendatCountryListVD = this.get(countryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCountryListVD);
        return viewData;
    }
    createEventListVD(locator) {
        let viewData = new EventListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let categoryListLocator = new CategoryListLocator();
        let dependendatCategoryListVD = this.get(categoryListLocator);
        let countryListLocator = new CountryNamesListLocator();
        let dependendatCountryListVD = this.get(countryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCategoryListVD);
        viewData.addDependency(dependendatCountryListVD);
        return viewData;
    }
    createNewsListVD(locator) {
        let viewData = new NewsListVD(this.logger, this.fetchSrvc, this.db, this.factory, locator);
        viewData.configureView();
        return viewData;
    }
    createWCupSeasonVD(locator) {
        let viewData = new WCupSeasonVD(this.logger, this.fetchSrvc, this.db, this.factory, locator);
        viewData.configureView();
        // Link season changed event with this service seasion changed stream.
        viewData.seasonChangedStream.subscribe((season) => this.seasonChangedStream.next(season));
        return viewData;
    }
    createAthleteResultListVD(locator) {
        let viewData = new AthleteResultListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        let countryListLocator = new CountryNamesListLocator();
        let dependendatCountryListVD = this.get(countryListLocator);
        viewData.configureView();
        viewData.addDependency(dependendatCountryListVD);
        return viewData;
    }
    getSeasonChangeStream() {
        return this.seasonChangedStream.asObservable();
    }
    createSeriesStateResultListVD(locator) {
        const viewData = new SeriesStageView(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createSeriesAmateursLocator(locator) {
        const viewData = new SeriesAmateurRankingView(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createSeriesTeamsRankingsLocator(locator) {
        const viewData = new SeriesTeamRankingView(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createRecordAreasList(locator) {
        const viewData = new RecordAreasListVD(this.logger, this.fetchSrvc, this.db, locator, this.factory, this.helper);
        return viewData;
    }
    createRecordHistoryList(locator) {
        const viewData = new RecordHistoryListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createSeriesList(locator) {
        const viewData = new SeriesView(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createProList(locator) {
        const viewData = new SeriesProView(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createdCompetitionDisciplines(locator) {
        const viewData = new CompetitionDisciplinesVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createdCompetitionLevels(locator) {
        const viewData = new CompetitionLevelsVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        return viewData;
    }
    createDvisionCategoryListVD(locator) {
        let viewData = new DivisionCategoryListVD(this.logger, this.fetchSrvc, this.db, this.factory, this.helper, locator);
        viewData.configureView();
        return viewData;
    }
}
ViewDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ViewDataService_Factory() { return new ViewDataService(i0.ɵɵinject(i1.LoggerService), i0.ɵɵinject(i2.WaHelperService), i0.ɵɵinject(i3.MemStorageService), i0.ɵɵinject(i4.DataFetchService), i0.ɵɵinject(i5.DatabaseService), i0.ɵɵinject(i6.AthletesDatabasePouchDbService), i0.ɵɵinject(i7.FactoryService), i0.ɵɵinject(i8.EnvironmentService)); }, token: ViewDataService, providedIn: "root" });
